import { type ReactElement, type SVGProps } from 'react';

export const MinusNaked = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M20 12.5H4V11.5H20V12.5Z" fill="currentColor" />
    </svg>
  );
};
